import React from 'react'

function Achitecture() {
  return (
    <div>
        <h1>Achitecture</h1>
    </div>
  )
}

export default Achitecture